import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getTechnicalSupportType = createAsyncThunk('/getTechnicalSupportType',
  async () => {
    const response = await axios.get('/GetTechnicalSupportType');
    return response.data;
});
export const setTechnicalSupports = createAsyncThunk('/SetSiriusTechnicalKnowledgeBaseDetail', async (req) => {
  const response = await axios.post(`/SetSiriusTechnicalKnowledgeBaseDetail`, req);
  return response.data;
});

export const setNewTechnicalSupports = createAsyncThunk('/SetSiriusTechnicalKnowledgeBaseWO', async (req) => {
  const response = await axios.post(`/SetSiriusTechnicalKnowledgeBaseWO`, req);
  return response.data;
});
export const getTechnicalSupports = createAsyncThunk('/GetSiriusTechnicalKnowledgeBaseWO', async () => {
  const response = await axios.get('/GetSiriusTechnicalKnowledgeBaseWO/0');
  return response.data;
});
export const getTechnicalSupportsParam = createAsyncThunk('/GetSiriusTechnicalKnowledgeBaseParam',
  async (ids) => {
    const response = await axios.get(`/GetSiriusTechnicalKnowledgeBaseParam/${ids[0]}/${ids[1]}/${ids[2]}/${ids[3]}`);
    return response.data;
  });
export const getTechnicalSupportDetails = createAsyncThunk('/GetSiriusTechnicalKnowledgeBaseDetail', async (QuestionAnswerId) => {
  const response = await axios.get(`/GetSiriusTechnicalKnowledgeBaseDetail/${QuestionAnswerId}`);
  return response.data;
});

export const setFrequentlyAskedQuestions = createAsyncThunk('/SetFrequentlyAskedQuestions', async (req) => {
  const response = await axios.post(`/SetFrequentlyAskedQuestions`, req);
  return response.data;
});
export const removeFrequentlyAskedQuestions = createAsyncThunk('/RemoveFrequentlyAskedQuestions', async (req) => {
  const response = await axios.post(`/RemoveFrequentlyAskedQuestions`, req);
  return response.data;
});
//HQ SUPPORT
export const setHQSupports = createAsyncThunk('/SetSiriusHQSupportDetail', async (req) => {
  const response = await axios.post(`/SetSiriusHQSupportDetail`, req);
  return response.data;
});
export const getHQSupports = createAsyncThunk('/GetHQSupportsWO', async () => {
  const response = await axios.get('/GetDigiportSearch/0');
  return response.data;
});
export const getHQSupportsParam = createAsyncThunk('/GetSiriusHQSupportParam',
async (ids) => {
  const response = await axios.get(`/GetSiriusHQSupportParam/${ids[0]}/${ids[1]}/${ids[2]}/${ids[3]}`);
  return response.data;
});
export const getHQSupportDetails = createAsyncThunk('/GetSiriusHQSupportDetail', async (HQSupportId) => {
  const response = await axios.get(`/GetSiriusHQSupportDetail/${HQSupportId}`);
  return response.data;
});


const technicalSupportSlice = createSlice({
  name: 'technicalSupport',
  initialState: {
    loading: false,
    error: '',
    TechnicalSupportType:[],
    TechnicalSupportData:[],
    TechnicalSupports:[]
  },
  reducers: {
  },
  extraReducers: {  
    [getTechnicalSupportType.pending]: (state) => {
      state.loading = true;
    },
    [getTechnicalSupportType.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTechnicalSupportType.fulfilled]: (state, action) => {
      state.TechnicalSupportType = action.payload;
      state.loading = false;
    },
    [setTechnicalSupports.pending]: (state) => {
      state.loading = true;
    },
    [setTechnicalSupports.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setTechnicalSupports.fulfilled]: (state, action) => {
      state.TechnicalSupportData = action.payload;
      state.loading = false;
    },
    
    [getTechnicalSupportDetails.pending]: (state) => {
      state.loading = true;
    },
    [getTechnicalSupportDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTechnicalSupportDetails.fulfilled]: (state, action) => {
      state.TechnicalSupportData = action.payload;
      state.loading = false;
    },
    
    [getTechnicalSupports.pending]: (state) => {
      state.loading = true;
    },
    [getTechnicalSupports.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTechnicalSupports.fulfilled]: (state, action) => {
      state.TechnicalSupports = action.payload;
      state.loading = false;
    },
    
    [getTechnicalSupportsParam.pending]: (state) => {
      state.loading = true;
    },
    [getTechnicalSupportsParam.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTechnicalSupportsParam.fulfilled]: (state, action) => {
      state.TechnicalSupports = action.payload;
      state.loading = false;
    },
    [setFrequentlyAskedQuestions.pending]: (state) => {
      state.loading = true;
    },
    [setFrequentlyAskedQuestions.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setFrequentlyAskedQuestions.fulfilled]: (state, action) => {
      state.TechnicalSupportData = action.payload;
      state.loading = false;
    },
    [removeFrequentlyAskedQuestions.pending]: (state) => {
      state.loading = true;
    },
    [removeFrequentlyAskedQuestions.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [removeFrequentlyAskedQuestions.fulfilled]: (state, action) => {
      state.TechnicalSupportData = action.payload;
      state.loading = false;
    }
    ,[setNewTechnicalSupports.pending]: (state) => {
      state.loading = true;
    },
    [setNewTechnicalSupports.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setNewTechnicalSupports.fulfilled]: (state, action) => {
      state.TechnicalSupportData = action.payload;
      state.loading = false;
    },
    [setHQSupports.pending]: (state) => {
      state.loading = true;
    },
    [setHQSupports.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setHQSupports.fulfilled]: (state, action) => {
      state.HQSupportData = action.payload;
      state.loading = false;
    },
    [getHQSupportDetails.pending]: (state) => {
      state.loading = true;
    },
    [getHQSupportDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getHQSupportDetails.fulfilled]: (state, action) => {
      state.HQSupportData = action.payload;
      state.loading = false;
    },
    [getHQSupports.pending]: (state) => {
      state.loading = true;
    },
    [getHQSupports.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getHQSupports.fulfilled]: (state, action) => {
      state.HQSupports = action.payload;
      state.loading = false;
    },
    [getHQSupportsParam.pending]: (state) => {
      state.loading = true;
    },
    [getHQSupportsParam.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getHQSupportsParam.fulfilled]: (state, action) => {
      state.HQSupports = action.payload;
      state.loading = false;
    }
  }
});
export const technicalSupportSliceActions = technicalSupportSlice.actions;
export default technicalSupportSlice;
